import "./BrandFilter.css";

function BrandFilter({
    brands,
    selectedBrand,
    setSelectedBrand
}) {

    return (

        <section className="brand-filter">

            <h2 className="brand-title">
                Popular Brands
            </h2>

            <div className="brand-list">

                <button
                    className={
                        selectedBrand === null
                            ? "brand-chip active"
                            : "brand-chip"
                    }
                    onClick={() => setSelectedBrand(null)}
                >
                    All
                </button>

                {brands.map((brand) => (

                    <button
                        key={brand.id}
                        className={
                            selectedBrand === brand.id
                                ? "brand-chip active"
                                : "brand-chip"
                        }
                        onClick={() => setSelectedBrand(brand.id)}
                    >
                        {brand.name}
                    </button>

                ))}

            </div>

        </section>

    );
}

export default BrandFilter;